<template>
  <b-row>
    <b-col cols="12">
      <b-row class="justify-content-between mb-3">
        <b-col cols="3" sm="6" md="3" class="d-flex align-items-end">
          <div>
            <label for="input">Rechercher</label>
            <b-input-group>
              <template #append>
                <b-input-group-text
                  v-if="!hasSearchInputBeenReseted || isSearchInputFocused || searchParams"
                  type="button"
                  @click="resetSearch"
                >
                  <font-awesome-icon icon="times" size="sm"></font-awesome-icon>
                </b-input-group-text>
              </template>

              <b-form-input
                id="input"
                v-model="searchParams"
                placeholder="Tapez pour rechercher"
                @focus="focusSearch"
                @blur="unfocusSearch"
                @keyup.enter="search"
              />
            </b-input-group>
            <small class="text-secondary ml-2"
              >Utilisez la touche Entrée pour lancer la recherche</small
            >
          </div>
        </b-col>
        <b-col cols="3" sm="6" md="3">
          <label>par page</label>
          <b-select
            v-model="pagination.pageSize"
            :options="[10, 20, 50, 100]"
            @input="getResolutionCatalog"
          ></b-select>
        </b-col>
      </b-row>
    </b-col>
    <b-col>
      <b-table
        class="agv-table td-middle"
        bordered
        :items="resolutionCatalog"
        :fields="fields"
        :busy="isBusy"
        show-empty
      >
        <!-- Heads -->
        <template #head(name)>
          <div class="d-flex align-items-center">
            <span class="mr-2" @click="setSort('name')">Nom</span>
            <font-awesome-icon
              v-if="tableHeaderSettings.sort.by == 'name' && tableHeaderSettings.sort.dir == 'desc'"
              icon="sort-up"
              @click="setSort('name', 'asc')"
            ></font-awesome-icon>
            <font-awesome-icon
              v-else-if="
                tableHeaderSettings.sort.by == 'name' && tableHeaderSettings.sort.dir == 'asc'
              "
              icon="sort-down"
              @click="setSort('name', 'desc')"
            ></font-awesome-icon>
            <font-awesome-icon v-else icon="sort" @click="setSort('name')"></font-awesome-icon>
          </div>
        </template>
        <template #head(resolutions)>
          <div class="d-flex align-items-center">
            <span class="mr-2" @click="setSort('resolutions')">Nombre de résolutions</span>
            <font-awesome-icon
              v-if="
                tableHeaderSettings.sort.by == 'resolutions' &&
                tableHeaderSettings.sort.dir == 'desc'
              "
              icon="sort-up"
              @click="setSort('resolutions', 'asc')"
            ></font-awesome-icon>
            <font-awesome-icon
              v-else-if="
                tableHeaderSettings.sort.by == 'resolutions' &&
                tableHeaderSettings.sort.dir == 'asc'
              "
              icon="sort-down"
              @click="setSort('resolutions', 'desc')"
            ></font-awesome-icon>
            <font-awesome-icon
              v-else
              icon="sort"
              @click="setSort('resolutions')"
            ></font-awesome-icon>
          </div>
        </template>
        <!-- Rows-->
        <template v-slot:cell(name)="row">
          <div class="text-left">
            <b-input
              :value="row.item.name"
              class="min-w-130"
              @change="updateProperty($event, row.item)"
            />
          </div>
        </template>
        <template v-slot:cell(resolutions)="row">
          <div class="text-left">
            {{ row.item.resolutions.length }}
          </div>
        </template>
        <template v-slot:cell(tags)="row">
          <div>
            <span v-for="tag in row.item.tags" :key="tag.id">
              <b-badge class="mr-1">{{ tag.name }}</b-badge>
            </span>
          </div>
        </template>
        <template v-slot:cell(_actions)="row">
          <div class="d-flex justify-content-center">
            <b-button
              class="tablebutton btn-edit"
              title="Modifier la résolution"
              variant="white"
              @click="editResolutionCatalog(row.item)"
            >
              <font-awesome-icon icon="pen" size="2x" />
            </b-button>
            <b-button
              class="tablebutton btn-red"
              title="Modifier la résolution"
              variant="white"
              @click="deleteResolutionCatalog(row.item)"
            >
              <font-awesome-icon icon="trash-alt" size="2x" />
            </b-button>
          </div>
        </template>
        <template #table-busy>
          <appIsLoading />
        </template>
        <template #empty>
          <span>{{ "Aucune donnée n'a été trouvée..." }}</span>
        </template>
      </b-table>
    </b-col>

    <b-col cols="12" class="text-center">
      <b-col cols="4" class="m-auto d-flex justify-content-center">
        <b-pagination
          v-model="pagination.page"
          :total-rows="pagination.rowCount"
          :per-page="pagination.pageSize"
          aria-controls="mt-table"
          @input="getResolutionCatalog"
        ></b-pagination>
      </b-col>
    </b-col>
  </b-row>
</template>
<script>
import ResolutionCatalogMW from "@/middlewares/ResolutionCatalog";
import ResolutionCatalogORM from "@/store/orm-axios/models/ResolutionCatalog";
import TagMW from "@/middlewares/Tag";

export default {
  components: {
    appIsLoading: () => import("@/components/snippets/IsLoading"),
  },
  data() {
    return {
      tableData: [],
      fields: [
        {
          key: "name",
          label: "Nom",
        },
        {
          key: "resolutions",
          label: "Nombre de résolutions",
        },
        {
          key: "tags",
          label: "Étiquettes",
        },
        {
          key: "_actions",
          label: "Actions",
        },
      ],
      pagination: {
        page: 1,
        pageSize: 10,
        rowCount: 0,
        pageCount: 0,
      },
      tableHeaderSettings: {
        filter: [
          {
            column: "name",
            value: "",
          },
        ],
        sort: {
          by: "created",
          dir: "desc",
        },
      },
      isBusy: true,
      searchParams: "",
      isSearchInputFocused: false,
      hasSearchInputBeenReseted: true,
    };
  },
  computed: {
    agencyId() {
      return Number(localStorage.getItem("agencyId"));
    },
    resolutionCatalog() {
      return ResolutionCatalogORM.query()
        .where("agency_id", this.agencyId)
        .with("tags|resolutions")
        .limit(this.pagination.pageSize)
        .orderBy("created", "desc")
        .get();
    },
  },
  async created() {
    await TagMW.FETCH(this.agencyId).catch(() => {});

    let queryParams = this.prepareQueryParams();
    ResolutionCatalogMW.QUERY_FETCH(this.agencyId, queryParams)
      .then(res => {
        let totalItems = res.response.data["hydra:totalItems"];
        this.pagination.rowCount = totalItems;
        this.tableData = res.response.data["hydra:member"];
        this.isBusy = false;
      })
      .catch(err => {
        this.isBusy = false;
      });
  },
  methods: {
    prepareQueryParams() {
      var queryParams = {
        filter: [],
        sort: {},
      };
      if (this.tableHeaderSettings.sort.by && this.tableHeaderSettings.sort.dir) {
        queryParams.sort["by"] = this.tableHeaderSettings.sort.by;
        queryParams.sort["dir"] = this.tableHeaderSettings.sort.dir;
      }
      this.tableHeaderSettings.filter.forEach(filter => {
        if (!!filter.value || filter.value === 0) {
          var preparedFilter = {
            column: filter.column,
            value: filter.value,
          };
          queryParams.filter.push(preparedFilter);
        }
      });
      return queryParams;
    },
    async getResolutionCatalog() {
      this.isBusy = true;
      var queryParams = this.prepareQueryParams();
      await ResolutionCatalogMW.FETCH_BY_PAGE(this.agencyId, queryParams, this.pagination)
        .then(res => {
          let totalItems = res.response.data["hydra:totalItems"];
          this.pagination.rowCount = totalItems;
          this.tableData = res.response.data["hydra:member"];
          this.isBusy = false;
        })
        .catch(err => {
          this.isBusy = false;
          // console.log("err: ", err);
        });
    },
    setSort(by, dir) {
      if (!dir) {
        if (this.tableHeaderSettings.sort.dir == "asc") {
          dir = "desc";
        } else {
          dir = "asc";
        }
      }
      // console.log("by", by);
      // console.log("dir", dir);
      this.tableHeaderSettings.sort.by = by;
      this.tableHeaderSettings.sort.dir = dir;
      // console.log(this.tableHeaderSettings.sort);
      this.getResolutionCatalog();
    },
    async updateProperty($ev, resolutionCatalog) {
      resolutionCatalog.name = $ev;
      ResolutionCatalogMW.PUT(resolutionCatalog);
    },
    editResolutionCatalog(resolutionCatalog) {
      this.isBusy = true;
      this.$router.push({ name: "edit-resolutions-catalog", params: { id: resolutionCatalog.id } });
    },
    deleteResolutionCatalog(resolutionCatalog) {
      var self = this;
      self
        .$swal(self.alertQuestion())
        .then(res => {
          if (res.value) {
            ResolutionCatalogMW.DELETE(resolutionCatalog)
              .then(() => {})
              .catch(err => {
                // console.log("error", err);
                self.$swal(self.alertError());
              });
          } else {
            // console.log("Cancel");
          }
        })
        .catch(err => {
          // console.log("error", err);
          self.$swal(self.alertError());
        });
    },
    search() {
      if (this.isBusy) return;

      this.hasSearchInputBeenReseted = false;

      this.tableHeaderSettings.filter[0].value = this.searchParams;
      this.getResolutionCatalog();
    },
    focusSearch() {
      this.isSearchInputFocused = true;
    },
    unfocusSearch() {
      this.isSearchInputFocused = false;
    },
    resetSearch() {
      this.hasSearchInputBeenReseted = true;
      this.isSearchInputFocused = false;

      this.searchParams = "";
      this.tableHeaderSettings.filter[0].value = this.searchParams;
      this.getResolutionCatalog();
    },
  },
};
</script>
